import { MINUTE_MS, roundToMinute } from "./roundToMinute";

/**
 * Единая точка расчёта момента экспирации ордера (мс).
 *
 * Обычный режим: now + duration — сделка живёт ровно duration секунд.
 * Режим Switch Time: флажок — это ближайшая минута, но не ближе минимально
 * допустимой. Минимум — минута, следующая за той, что содержит момент
 * "now + 1 минута" (см. roundToMinute): она всегда даёт зазор строго больше
 * 30 сек от now, какой бы ни была текущая секунда. Ровно на 30-й секунде
 * минуты этот минимум сам сдвигается на минуту вперёд — например, в 21:12:55
 * округление 21:12:55+30с дало бы 21:13:00 (зазор всего 5 сек), поэтому
 * применяется минимум и флажок становится 21:14:00.
 */
export const getExpiryTimestamp = (
  nowMs: number,
  durationSeconds: number,
  switchTimeEnabled: boolean,
): number => {
  const rawExpiry = nowMs + durationSeconds * 1000;
  if (!switchTimeEnabled) return rawExpiry;

  const minExpiry = roundToMinute(nowMs + MINUTE_MS);
  return Math.max(roundToMinute(rawExpiry), minExpiry);
};
